// extracted by mini-css-extract-plugin
module.exports = {"footer":"_3eDQk","footerGroup":"v1n7b","footerGroupLanguages":"XMx+7","footerItem":"oJYTM","langItem":"klDTi"};